import { type TypographyComponentWithType } from './Typography.types';
import { createTypographyComponent } from './Typography.utils';
import TypographyBase from './TypographyBase';

export const Text = createTypographyComponent(TypographyBase, {
    displayName: 'Text',
    defaultAs: 'span',
    type: 'text'
}) as TypographyComponentWithType<'span'>;

export const H1 = createTypographyComponent(TypographyBase, {
    displayName: 'H1',
    defaultAs: 'h1',
    type: 'h1'
});

export const H2 = createTypographyComponent(TypographyBase, {
    displayName: 'H2',
    defaultAs: 'h2',
    type: 'h2'
});

export const H3 = createTypographyComponent(TypographyBase, {
    displayName: 'H3',
    defaultAs: 'h3',
    type: 'h3'
});

export const H4 = createTypographyComponent(TypographyBase, {
    displayName: 'H4',
    defaultAs: 'h4',
    type: 'h4'
});

export const H5 = createTypographyComponent(TypographyBase, {
    displayName: 'H5',
    defaultAs: 'h5',
    type: 'h5'
});

export const Small = createTypographyComponent(TypographyBase, {
    displayName: 'Small',
    defaultAs: 'small',
    type: 'small'
});

export const ExtraSmall = createTypographyComponent(TypographyBase, {
    displayName: 'ExtraSmall',
    defaultAs: 'small',
    type: 'extra-small'
});

export const Label = createTypographyComponent(TypographyBase, {
    displayName: 'Label',
    defaultAs: 'span',
    type: 'label'
});

export const Paragraph = createTypographyComponent(TypographyBase, {
    displayName: 'Paragraph',
    defaultAs: 'p',
    type: 'text'
});
